export const shouldReconcileTransientEmptyQueue = ({
    queuedSongCount,
    hasExplicitCurrentSong,
    hasLocalCurrentSong,
    isPlaying,
    previousSessionSongCount,
}: {
    queuedSongCount: number;
    hasExplicitCurrentSong: boolean;
    hasLocalCurrentSong: boolean;
    isPlaying: boolean;
    previousSessionSongCount: number;
}): boolean =>
    queuedSongCount === 0 &&
    hasLocalCurrentSong &&
    isPlaying &&
    (!hasExplicitCurrentSong || previousSessionSongCount > 1);
